import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Add from "@material-ui/icons/Add";
import WebIcon from "@material-ui/icons/Web";
import CardTable from "components/CardTable/CardTable";
import { TableInputs } from "components/CardTable/TableInputs";
import RegularButton from "components/CustomButtons/Button";
import { ModalV2 } from "components/Modal/ModalV2";
import { useSearch } from "hooks/useSearch";
import { useToggle } from "hooks/useToggle";
import { AddInventoryForm } from "./AddInventoryForm";
import { columns } from "./columns";
import {
  getInventories,
  inventoriesSearchInputs,
  resetIsNewInventory,
} from "redux/actions/inventories/inventoriesAction";
import { useRuleValidator } from "hooks/useRuleValidator";
import { PERMISSIONS } from "router/permissions";

export const InventoriesView = () => {
  const dispatch = useDispatch();
  const { inventories, startDate, endDate, station } = useSelector(
    ({ inventories }) => inventories
  );
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { buildCompLoadings, setSnackbar } = useSearch();
  const [open, setOpen] = useToggle();
  const canCreate = useRuleValidator(PERMISSIONS.INVENTORIES_CONTROL_CREATE);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!station) return setSnackbar("Seleccione una planta", "warning");
    dispatch(getInventories(startDate, endDate, station?.id));
  };

  useEffect(() => {
    !isLoadingComp?.loadingInventories &&
      buildCompLoadings([
        "loadingInventories",
        "loadingInventory",
        "loadingInventoryType",
        "loadingInventoryExistence",
        "loadingGeneralInventory",
        "loadingSavingInventory",
        "loadingReopenInventory",
        "loadingUpdateDigitalInventory",
        "inventoryConf",
        'saveShipment',
        'deleteShipment',
      ]);
    dispatch(resetIsNewInventory());
  }, []);

  return (
    <>
      <CardTable
        data={inventories}
        columns={columns}
        rowsText="Inventarios"
        icon={<WebIcon />}
        hasHeader
        hasControl
        blockBtn
        isLoading={isLoadingComp?.loadingInventories}
        title={`Control de inventarios`}
        // tableContent={<FilterInputs />}
        tableContent={
          <TableInputs
            reducer="inventories"
            dates
            stations
            dispatchAction={inventoriesSearchInputs}
            submitAction={handleSubmit}
            loading={isLoadingComp?.loadingInventories}
          />
        }
        controls={
          <>
            {canCreate && (
              <RegularButton
                round
                justIcon
                color="info"
                tooltip="Nuevo inventario"
                size="sm"
                onClick={setOpen}
              >
                <Add style={{ margin: 0 }} />
              </RegularButton>
            )}
          </>
        }
      />
      <ModalV2
        open={open}
        onClose={setOpen}
        title={`Crear nuevo inventario `}
        justConfirm
      >
        <AddInventoryForm onClose={setOpen} />
      </ModalV2>
    </>
  );
};
